module.exports = __webpack_public_path__ + "img/popup.a92a0f12.png";